import { render, staticRenderFns } from "./Period.vue?vue&type=template&id=c1319e44&scoped=true"
import script from "./Period.vue?vue&type=script&lang=js"
export * from "./Period.vue?vue&type=script&lang=js"
import style0 from "./Period.vue?vue&type=style&index=0&id=c1319e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1319e44",
  null
  
)

export default component.exports